import React, {Component} from 'react'
import {_getWorkerStatistics} from "../../../../../services/apis/WorkerServices"
import {Badge} from "reactstrap"

const badgeColorMap = {
    active: 'success',
    checkpoint: 'warning',
    wrong_pass: 'warning',
    logout: 'danger',
    disabled: 'danger',
}

class WorkerStatistics extends Component {
    state = {
        statistics: [],
        loading: false
    }

    _refresh = null

    componentDidMount() {
        this._fetchStatistics()
        this._refresh = setInterval(this._fetchStatistics, 5000)
    }

    componentWillUnmount() {
        this._refresh && clearInterval(this._fetchStatistics)
    }

    _fetchStatistics = async () => {
        if (this.state.loading) return

        this.setState({
            loading: true
        })

        try {
            const {success, data} = await _getWorkerStatistics()
            const newState = {
                loading: false
            }

            if (success) {
                newState.statistics = data
            }

            this.setState(newState)
        } catch (e) {
            this.setState({
                loading: false
            })
        }
    }

    render() {
        return (
            <div className="WorkerStatistics">
                {
                    this.state.statistics.map((statistics, index) => {
                        const {status, total} = statistics
                        return (
                            <div key={index} className="Statistic">
                                <span className="Status">
                                    <Badge color={badgeColorMap[status]} pill>{status}</Badge>
                                </span>
                                <span className="Total">{total}</span>
                            </div>
                        )
                    })
                }
            </div>
        )
    }
}

export default WorkerStatistics



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/workers/components/WorkerStatistics.js